"use client";

import {
	HmcButton,
	HmcIcon,
	HmcCard,
	HmcContainerHeader,
} from "@adi-ctx/harmonic-core-components-react";
import { t } from "@/utils/";
import { Link, useAuth } from "@/components";
import { LOGIN_URL_CMS } from "@/lib/constants/auth.constants";

/**
 * Login UI component for the CMS
 */
export default function Login() {
	const { isAuthenticated, isAuthenticatingInProgress } = useAuth();

	if (isAuthenticatingInProgress || isAuthenticated) {
		return;
	}

	return (
		<div className="mx-auto w-full bg-[var(--hmc-color-gray-100)] p-4 sm:w-[640px] sm:py-10">
			<HmcCard data-testid="cms-login">
				<HmcContainerHeader
					slot="card-header"
					heading={t("login.title")}
					data-testid="cm-login-title"
				>
					{t("login.title")}
					<HmcIcon
						className="block"
						slot="icon"
						name="user-m"
						data-testid="cms-login-title-icon"
					/>
				</HmcContainerHeader>

				<div className="hmc-body-s">
					<p className="mb-4 font-bold" data-testid="cms-login-subtitle">
						{t("login.subtitle")}
					</p>
					<p data-testid="cms-login-desc">{t("login.desc")}</p>
				</div>

				<div slot="card-footer" className="flex justify-end">
					<Link
						isSameTab
						href={`${LOGIN_URL_CMS}`}
						data-testid="cms-login-link"
					>
						<HmcButton
							isFullWidth
							autofocus
							kind="primary"
							size="sm"
							type="button"
							data-testid="cms-login-button"
						>
							{t("login.button")}
						</HmcButton>
					</Link>
				</div>
			</HmcCard>
		</div>
	);
}
